export function calcOreDillution (actualVolume, designVolume, underBreakVolume) {
    console.log(actualVolume, designVolume, underBreakVolume,"actualVolume, designVolume, underBreakVolume")
    const dillution = 100 * ((actualVolume / designVolume)) / (designVolume - underBreakVolume);
    return dillution;
}